import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import OrganizationList from './components/organization-list.vue';
let default_1 = class extends Vue {
};
default_1 = __decorate([
    Component({
        name: 'OrganizationTable',
        components: {
            'organization-list': OrganizationList,
        },
    })
], default_1);
export default default_1;
